import {gql} from "@apollo/client";

// Resolved "who serves this customer" (IBM-972) for the dashboard widget:
// client assignment → region default → global fallback, with the answering
// step in `source`. Null only when no global fallback is configured anywhere.
export const ClientServiceUnit = gql`
    query ClientServiceUnit($clientId: ID!) {
        client(clientId: $clientId) {
            id
            serviceUnit {
                source
                unit {
                    id
                    type
                    name
                    email
                    phone
                    serviceContacts {
                        id
                        name
                        email
                        phone
                        role
                    }
                }
            }
        }
    }
`;
